"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _lodash = /*#__PURE__*/ _interop_require_default(require("lodash"));
var _moment = /*#__PURE__*/ _interop_require_default(require("moment"));
var _getreleasetimes = /*#__PURE__*/ _interop_require_default(require("../helpers/get-release-times"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var INCLUSIVE_A_EXCLUSIVE_B = '[)';
// Returns true if offer is active at either current datetime or effectiveDate (if passed in scenario).
var isActive = function(offer) {
    var scenario = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var effectiveDate = (0, _moment.default)(_lodash.default.get(scenario, 'effectiveDate', new Date()));
    var _getReleaseTimes = (0, _getreleasetimes.default)(offer), startTime = _getReleaseTimes.startTime, endTime = _getReleaseTimes.endTime;
    if (startTime && endTime) {
        return effectiveDate.isBetween(startTime, endTime, null, INCLUSIVE_A_EXCLUSIVE_B);
    }
    if (startTime) {
        return effectiveDate.isSameOrAfter(startTime);
    }
    if (endTime) {
        return effectiveDate.isBefore(endTime);
    }
    return true;
};
var _default = isActive;
